<!-- @let multiplesOf = soldInMultiplesOf(); -->
<div>
  <ideal-cart-stepper-input
    #lengthStepper
    [control]="lengthControl"
    label="Length"
    placeholder=""
    [clearMode]="true"
    (keydown.enter)="onLengthEnter()"
  >
    @if (conflicted()) {
      <mat-error>Length already exists</mat-error>
    } @else if (lengthControl.hasError("min")) {
      <mat-error>Must be at least 1</mat-error>
    }
  </ideal-cart-stepper-input>
</div>
<div>
  <ideal-cart-stepper-input
    #quantityStepper
    [control]="quantityControl"
    [label]="'Qty'"
    placeholder=""
    [clearMode]="quantityClearMode()"
    (keydown.enter)="onQuantityEnter()"
    (decremented)="onQuantityDecrement()"
  >
    <!-- @if (quantityControl.hasError("min")) {
    <mat-error>Must be at least 1</mat-error>
  } @else if (multiplesOf > 1 && qty === 0) {
    
  <mat-hint class="multiples-hint">
    Sold in multiples of {multiplesOf, plural,
    =1 { {{ multiplesOf | i18nPlural: displayUnitLabel() }}}
    other { {{ multiplesOf | number }} {{ multiplesOf | i18nPlural: displayUnitLabel() }}}
  }
</mat-hint>
} @else if (multiplesOf > 1 && qty > 0) {
  <mat-hint class="multiples-hint"
  ><span value>{{ qty | number }}</span> x <span multiples>{{ multiplesOf | number }}</span> =
  <span total>{{ qty * multiplesOf | number }}</span></mat-hint
  >
} -->
  </ideal-cart-stepper-input>
</div>

@if (!conflicted() && lengthControl.valid && quantityControl.valid) {
  <mat-hint>
    @let len = lengthControl.value ?? 0;
    @let qty = quantityControl.value ?? 0;
    @let price = pricing()?.price ?? 0;

    <span qty>{{ len | number }}</span>
    <span unit>{{ qty | i18nPlural: displayUnitLabel() }}</span>
    <span operator>x</span>
    <span qty>{{ qty | number }}</span>
    <span operator>=</span>
    <span qty>{{ totalLen | number }}</span>
    <span unit>{{ totalLen | i18nPlural: displayUnitLabel() }}</span>
    @if (price > 0) {
      <span operator>&#64;</span>
      <span price [innerHTML]="price | currencyHtml"></span>
    }
  </mat-hint>
}
<!-- <pre>{{pricing() | json}}</pre> -->
